import React from 'react';
import TemplateComponent, {TemplateComponentProps} from "../../containers/template_page/template_component/template_component";
import Slider from "react-slick";
import TimelinePerson, {TimelinePersonData} from "./timeline_person/timeline_person";
import "./timeline_slider.scss";
import {TFunction} from "i18next";


interface TimelineData {
    title?: string;
    person: TimelinePersonData[];
}

/**
 * The Timeline Slider component show a list of items (for example users), each of them with a title,
 * a start date and an optional end date
 *
 * The timeline is scrollable and finite
 */
class TimelineSlider extends TemplateComponent<TimelineData, TemplateComponentProps<TimelineData>> {

    constructor(props: TemplateComponentProps<TimelineData>) {
        super(props);

        this.requireInternationalization = true;
    }


    internationalComponentRender(data: TimelineData, t: TFunction): React.ReactElement<any> {
        const settings = {
            dots: false,
            variableWidth: true,
            centerMode: false,
            rows: 1,
            infinite: false,
            arrows: true,
            swipeToSlide: true,
            touchMove: true,
            touchThreshold: 200,
            slidesToScroll: 1,
            speed: 300,
            cssEase: "cubic-bezier(.19,.8,.6,1.2)"
        };

        return (
            <div className="timeline-slider">
                {data.title &&
                    <h3 className="component-title">{data.title}</h3>
                }
                <Slider {...settings}>
                    {
                        // For each person we add a timeline block with the title and the dates
                        data.person.map((person, index) =>
                            <TimelinePerson key={`person-${index}`} {...person} t={t}/>
                        )
                    }
                </Slider>
            </div>
        )
    }

}

export default TimelineSlider;